<form [formGroup]="form" (ngSubmit)="save()" class="p-fluid dialog-form pt-0">

  <!--  Icon-Auswahl -->
  @if (showIcon) {
  <section class="form-section">
    <label class="section-label">Icon auswählen: </label>

    <div class="icon-selector-container">
      <button pButton type="button" icon="pi pi-chevron-left" (click)="previousItem()"
        class="p-button-rounded p-button-text p-button-secondary" aria-label="Vorherige Icons">
      </button>

      <div class="icon-grid">
        @for (item of currentItems; track item) {
        <div class="icon-box" [class.active]="isSelected(item)" (click)="selectItem(item)" [title]="item">
          <i [class]="'pi ' + item"></i>
        </div>
        }
      </div>

      <button pButton type="button" icon="pi pi-chevron-right" (click)="nextItem()"
        class="p-button-rounded p-button-text p-button-secondary" aria-label="Nächste Icons">
      </button>
    </div>
  </section>
  }

  <section class="form-section">
    <div class="field-group mb-4">
      <label for="labelInput" class="section-label">Name: </label>
      <input id="labelInput" pInputText formControlName="label" [placeholder]="fieldConfig.labelPlaceholder"
        class="p-inputtext-lg" />
    </div>
    <div class="field-group">
      <label for="valueInput" class="section-label">Wert: </label>
      <input id="valueInput" pInputText formControlName="value" [placeholder]="fieldConfig.valuePlaceholder"
        class="p-inputtext-lg" />
    </div>
  </section>

  <!-- Farbe & Vorschau -->
  @if (showColor || showIcon) {
  <section class="form-section">
    <label class="section-label">Farbe & Icon:</label>
    <div class="preview-card shadow-1">
      @if (showColor) {
      <div class="color-controls">
        <p-colorPicker formControlName="color" format="hex" appendTo="body">
        </p-colorPicker>
        <input pInputText formControlName="color" maxlength="7" spellcheck="false"
          class="hex-input font-mono p-inputtext-sm" placeholder="#000000" />
      </div>
      }
      @if (showIcon) {
      <div class="icon-preview-wrapper shadow-3">
        <i [class]="form.get('icon')?.value" [style.color]="form.get('color')?.value">
        </i>
      </div>
      }
    </div>
  </section>
  }
  <footer class="form-actions">
    <button pButton type="button" label="Abbrechen" class="p-button-text p-button-danger" (click)="ref.close()">
    </button>
    <button pButton type="submit" label="Speichern" icon="pi pi-check" [disabled]="form.invalid">
    </button>
  </footer>
</form>